module.exports = __webpack_public_path__ + "img/HC1003-161.581488ba.jpg";